import { Flex } from 'components/shared/flex'
import { ReactNode } from 'react'
import styled from 'styled-components'
import Logo from 'components/../../public/craif_logo_b.png'

type LedgerHeaderProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    headerTitle?: string
    recordTypeNum?: string
    versionNum?: string
    originalDocument?: ReactNode
    timestamp?: string
}

const Th = styled.th`
    border: solid 1px black;
    padding: 5px;
    text-align: center;
    min-width: 30px;
`

const Td = styled.td`
    border: solid 1px black;
    padding: 10px 5px;
    text-align: center;
`

export const LedgerHeader = (props: LedgerHeaderProps): JSX.Element => {
    const { headerTitle, recordTypeNum, versionNum, originalDocument, timestamp } = props
    return (
        <Flex justifyContent="center">
            <table style={{ border: '2px solid black', width: '100%', margin: '20px 0px 10px 0px', fontSize: 10 }}>
                <thead>
                    <Th colSpan={4}>Laboratory</Th>
                </thead>
                <tbody>
                    <tr>
                        <Td colSpan={2} style={{ padding: 0 }}>
                            <img src={Logo} style={{ maxHeight: 50 }}></img>
                        </Td>
                        <Td>記録書番号</Td>
                        <Td>{`LFRM-${recordTypeNum}`}</Td>
                    </tr>
                    <tr>
                        <td style={{ border: 'solid 1px', padding: 2, textAlign: 'center' }}>記録書名</td>
                        <td style={{ border: 'solid 1px', padding: 2, textAlign: 'center' }}>{headerTitle}</td>
                        <td style={{ border: 'solid 1px', padding: 2, textAlign: 'center' }}>改定版数</td>
                        <td style={{ border: 'solid 1px', padding: 2, textAlign: 'center' }}>{versionNum}</td>
                    </tr>
                    <tr>
                        <td style={{ border: 'solid 1px', padding: 2, textAlign: 'center' }}>記録識別番号</td>
                        <td style={{ border: 'solid 1px', padding: 2, textAlign: 'center' }}>
                            <div>{`LRCD-${recordTypeNum}_${timestamp}`}</div>
                        </td>
                        <td style={{ border: 'solid 1px', padding: 2, textAlign: 'center' }}>親文書番号</td>
                        <td style={{ border: 'solid 1px', padding: 2, textAlign: 'center' }}>{originalDocument}</td>
                    </tr>
                </tbody>
            </table>
        </Flex>
    )
}

type LedgerFooterProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    page?: number
}
export const LedgerFooter = (props: LedgerFooterProps): JSX.Element => {
    const { page } = props
    return (
        <Flex justifyContent="center">
            <footer style={{ fontSize: 13, position: 'absolute', bottom: 30, textAlign: 'center' }}>
                <div>{page}</div>
                <div>Confidential Property for Craif Inc</div>
            </footer>
        </Flex>
    )
}
